// extracted by mini-css-extract-plugin
export default {"container":"Switcher_container__JhRyj","input":"Switcher_input__K3XB9","switcher":"Switcher_switcher__Jrwt1"};